import React from 'react'
import LazyLoopingVideo from '../LazyLoopingVideo'

interface CabinHeroVideoProps {
    /** Muted, looping hero video for the cabin (mp4). */
    src: string
    /** Matches the hero `<Image>` box so the video→image swap is seamless. */
    width: number
    height: number
    top: number
    /** Same left-fade mask as the hero image so the edge treatment is identical. */
    maskImage?: string
    objectPosition?: string
    /** Fired once the video can play — lets the hero drop its poster image. */
    onReady?: () => void
}

/** Mirrors the hero `<Image>`'s left-to-right fade so the video edges match the poster. */
const DEFAULT_MASK = 'linear-gradient(90deg, transparent 0%, #000 26%)'

/**
 * Lazily-mounted cabin hero video for the SRP subheader. The themed hero image
 * (see PESrpHero) paints instantly and acts as the loading fallback; this video
 * cross-fades in over it once it can play. Positioning mirrors the hero image box.
 */
const CabinHeroVideo: React.FC<CabinHeroVideoProps> = ({
    src,
    width,
    height,
    top,
    maskImage = DEFAULT_MASK,
    objectPosition = 'right center',
    onReady,
}) => (
    <LazyLoopingVideo
        src={src}
        objectPosition={objectPosition}
        onReady={onReady}
        style={{
            position: 'absolute',
            top: `${top}px`,
            right: 0,
            width: `${width}px`,
            height: `${height}px`,
            pointerEvents: 'none',
            maskImage,
            WebkitMaskImage: maskImage,
        }}
    />
)

export default CabinHeroVideo
